import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { LoaderComponent } from '../../../../components/loader/loader.component';
// Constants
import { Illustration, RELOADED_ANIMATIONS, RELOADED_VARIANTS, } from '@kubit/web-ui-product-components';
import { EMPTY_STATUS_CONSTANTS } from '../../../../components/empty-status/constants/empty-status.constants';
const EmptyStatusIllustrationLoaderComponent = ({ showLoader, image, }) => {
    if (showLoader) {
        return (_jsx(LoaderComponent, { animation: RELOADED_ANIMATIONS.animation_loader_primary, size: RELOADED_VARIANTS.ThirdPartyAnimationSizesType.EXTRA_LARGE }));
    }
    return _jsx(Illustration, { ...EMPTY_STATUS_CONSTANTS.ILLUSTRATION_PROPS, illustration: image });
};
export { EmptyStatusIllustrationLoaderComponent };
//# sourceMappingURL=illustration-loader.component.js.map